/**
 * Created by Bart Decorte
 * Date: 11/09/2021
 * Time: 16:48
 */
import UploadPreview from './UploadPreview';

export default class UploadPreviewListItem extends UploadPreview {
  constructor(rootEl, params = {}) {
    super(rootEl, params);
    this.miniatureBoxWidth = 100;
    this.miniatureBoxHeight = 100;
  }

  setProgress(progress) {
    this.progressEl().style.width = this.progressWidth(progress) + '%';
  }

  setState(state) {
    this.progressEl().classList.add(`bg-${state}`);
  }

  filenameEl() {
    return this.rootEl.querySelector('.js-upload__filename');
  }

  miniatureEl() {

  }

  progressEl() {
    return this.rootEl.querySelector('.js-upload__progress');
  }

  btnClearEl() {
    return this.rootEl.querySelector('.js-upload__btn--clear');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/uploads/UploadPreviewListItem.js